import React, { Component } from "react";
import { toast } from "react-toastify";
import UsuarioService from "../../services/UsuarioService";
import BtnButton from "../../components/forms/elements/BtnButton";

const TEMPO_POLLING = 5000; //ms - de quanto em quanto tempo perguntamos se o vínculo saiu

/**
 * Modal do vínculo com o Telegram.
 *
 * Gera um QR Code com o deep link do bot (https://t.me/<bot>?start=<token>) e fica
 * consultando o status a cada 5 segundos. Quem grava o chat_id é o webhook do Telegram,
 * então a tela só observa - ao detectar o vínculo, fecha e avisa quem a abriu.
 */
export default class FormTelegramVinculo extends Component {

    constructor(props) {
        super(props);

        this.gerarVinculo = this.gerarVinculo.bind(this);
        this.verificarStatus = this.verificarStatus.bind(this);
        this.pararTimers = this.pararTimers.bind(this);

        this.timerPolling = null;
        this.timerContagem = null;

        this.state = {
            qrCode: "",
            deepLink: "",
            nrSegundos: 0,
            flExpirado: false,
            flCarregando: true
        };
    }

    componentDidMount() {
        this.gerarVinculo();
    }

    componentWillUnmount() {
        //sem isso o polling continua rodando depois que o modal fecha
        this.pararTimers();
    }

    pararTimers() {
        if (this.timerPolling) {
            clearInterval(this.timerPolling);
            this.timerPolling = null;
        }

        if (this.timerContagem) {
            clearInterval(this.timerContagem);
            this.timerContagem = null;
        }
    }

    gerarVinculo() {
        this.pararTimers();
        this.setState({ flCarregando: true, flExpirado: false });

        UsuarioService.telegramVinculo((response) => {

            this.setState({
                qrCode: response.qrCode,
                deepLink: response.deepLink,
                //conta a partir da resposta em vez de comparar com dhExpiracao:
                //evita depender do relógio da máquina do usuário
                nrSegundos: parseInt(response.nrMinutosExpiracao) * 60,
                flCarregando: false
            });

            this.timerPolling = setInterval(this.verificarStatus, TEMPO_POLLING);

            this.timerContagem = setInterval(() => {
                this.setState((state) => {
                    var nrSegundos = state.nrSegundos - 1;

                    if (nrSegundos <= 0) {
                        this.pararTimers();
                        return { nrSegundos: 0, flExpirado: true };
                    }

                    return { nrSegundos: nrSegundos };
                });
            }, 1000);

        }, () => {
            this.setState({ flCarregando: false });
        });
    }

    verificarStatus() {
        UsuarioService.telegramStatus((response) => {
            if (response.flVinculado) {
                this.pararTimers();
                toast.success("Telegram vinculado com sucesso!");
                this.props.onSave({ cdTelegramId: response.cdTelegramId });
            }
        }, () => {
            //erro de rede/sessão: para o polling para não repetir o toast a cada 5s
            this.pararTimers();
            this.setState({ flExpirado: true });
        });
    }

    getTempoRestante() {
        var minutos = Math.floor(this.state.nrSegundos / 60);
        var segundos = this.state.nrSegundos % 60;
        return `${minutos}:${segundos < 10 ? "0" + segundos : segundos}`;
    }

    render() {
        return (
            <div className="text-center">

                <p className="mb-3">
                    Abra a câmera do celular e leia o QR Code abaixo, ou toque em <strong>Abrir no Telegram</strong> se
                    já estiver no celular. Depois é só enviar a mensagem que o Telegram sugerir.
                </p>

                {this.state.flExpirado ?
                    <div className="my-4">
                        <p className="text-muted">Este QR Code expirou.</p>
                        <BtnButton className="btn-primary" onClick={this.gerarVinculo}>
                            Gerar novo QR Code
                        </BtnButton>
                    </div>
                    : <></>
                }

                {!this.state.flExpirado && this.state.qrCode ?
                    <>
                        <div className="mb-3">
                            <img style={{ maxWidth: "260px" }} className="img-fluid" src={this.state.qrCode} alt="QR Code para vincular o Telegram" />
                        </div>

                        <div className="mb-3">
                            <a className="btn btn-primary" href={this.state.deepLink} target="_blank" rel="noreferrer">
                                Abrir no Telegram
                            </a>
                        </div>

                        <div className="text-muted">
                            <small>Aguardando a leitura... O código expira em {this.getTempoRestante()}.</small>
                        </div>
                    </>
                    : <></>
                }

                {this.state.flCarregando ?
                    <div className="text-muted my-4">
                        <small>Gerando o QR Code...</small>
                    </div>
                    : <></>
                }

                <div className="mt-4">
                    <BtnButton className="btn-outline-secondary" onClick={this.props.onClose}>
                        Cancelar
                    </BtnButton>
                </div>
            </div>
        );
    }
}
